export const workspace = {
  routes: [
    {
      path: "/workspace/library/unit",
      component: () => import("../workspace-library-unit-view"),
    },
  ],
};

export const management = {
  routes: [
    {
      path: "/management/unit",
      component: () => import("../management-library-unit-view"),
    },
  ],
};

export const organization = {
  routes: [
    {
      path: "/organization/unit-hierarchy",
      component: () => import("../organization-unit-graph-view"),
    },
    // {
    //   path: "/unit",
    //   component: () => import("../organization-unit-view"),
    // },
    {
      path: "/unit/:id",
      component: () => import("../organization-unit-view"),
    },
    {
      path: "/unit/:id/processes",
      component: () => import("../organization-unit-process-graph-view"),
    },
  ],
};
